export default __webpack_public_path__ + "static/media/ai2.2fa8aa07.png";